angular.module('app.filters')
.filter('lessThanFilter', [
  "$log", "$filter", function($log, $filter) {
    return function(list, filterProperty, filterValue) {
      var filterList, filteredList;
      filteredList = [];
      filterList = angular.copy(list);
      filterList.forEach(function(item, index, array) {
        if (item[filterProperty] < filterValue) {
          filteredList.push(item);
        }
      });
      return filteredList;
    };
  }
])


// WEBPACK FOOTER //
// ./scripts/shared/filters/less-than.js